import { AddPlanDTO } from "@/domain/dto/AddUsersToPlanDTO";
import { isDateFuture } from "@/utils/Validators";

export class PlanValidator {

    static validateAddUsers(params: AddPlanDTO) {
        if (!params.partnership_id) {
            throw new Error('Id da parceria inválido')
        }
        if (!params.plans[0]?.quantity && !params.plans[1]?.quantity) {
            throw new Error('Informe uma quantidade')
        }
        if (!isDateFuture(params.expiration_date)) {
            throw new Error('A data deve ser no futuro')
        }
        return true
    }
}